module.exports = __webpack_public_path__ + "static/media/circle_unchecked.6e07d53e.svg";